<template>
    <div>
        <!--<div style="width: 50%;margin: 20px 0;">
            <span class="searchName" >品名/批次号:</span>
            <el-input
                    size="mini"
                    class="mr10"
                    placeholder="品名或批次号 搜索"
                    v-model="cpinput"
                    clearable>
            </el-input>
            <el-button type="primary" @click="searchData" style="margin-left: 30px" :class="baseerp+'btn'" size="mini">搜索</el-button>
        </div>-->
        <el-table
                size="mini"
                border
                ref="multipleTable"
                :data="detailsData"
                row-key="vc_unique"
                height="220"
                tooltip-effect="dark"
                :row-class-name="tableRowClassName"
                @selection-change="handleSelectionChange"
                style="width: 100%">
            <template slot="empty">
                <p>{{dataText}}</p>
            </template>
            <el-table-column
                    align="left"
                    type="selection"
                    :reserve-selection="true"
                    width="55">
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="i_id"
                    label="ID"
                    width="60"
            >
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_unit"
                    label="单位"
            >
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="f_num"
                    label="数量"
                    show-overflow-tooltip>
                <!--<template slot-scope="scope">
                    <el-input-number :controls="false" :precision="3" class="" size="mini" v-model="scope.row.f_num" ></el-input-number>
                </template>-->
            </el-table-column>
            <!--<el-table-column
                    align="left"
                    prop="f_cbdj"
                    label="成本单价">
                &lt;!&ndash;<template slot-scope="scope">
                    <el-input-number :controls="false" :precision="3" class="" size="mini" v-model="scope.row.f_cbdj" ></el-input-number>
                </template>&ndash;&gt;
            </el-table-column>-->
            <el-table-column
                    align="left"
                    prop="f_jsdj"
                    label="结算单价">
               <!-- <template slot-scope="scope">
                    &lt;!&ndash;<el-input-number :controls="false" :min="0" :precision="5" class="" size="mini" v-model="scope.row.f_jsdj" >&ndash;&gt;
                    &lt;!&ndash;{{ (scope.row.f_jsdj = scope.row.f_zj /scope.row.f_num)| keepTwoNum }}&ndash;&gt;
                    &lt;!&ndash;</el-input-number>&ndash;&gt;
                </template>-->
            </el-table-column>
            <!--<el-table-column
                    sortable
                    prop="f_zj"
                    label="总价">
                <template slot-scope="scope">
                    &lt;!&ndash;<el-input-number :controls="false" :min="0" :precision="2" class="" size="mini" v-model="scope.row.f_zj" >&ndash;&gt;
                        {{ (scope.row.f_zj = scope.row.f_num *scope.row.f_jsdj) | keepTwoNum}}
                    &lt;!&ndash;</el-input-number>&ndash;&gt;
                </template>
            </el-table-column>-->
        </el-table>
        <!--<div class="tbRight">
            <div class="paginationBox textRig" >
                <el-pagination
                        background
                        layout="prev, pager, next"
                        @current-change="pageCurrentChange"
                        :current-page.sync="currentPage"
                        :total="tableTotal">
                </el-pagination>
            </div>
        </div>-->
        <div slot="footer" class="dialog-footer" style="text-align: center;margin-top: 20px">
            <el-button type="primary" @click="saveForm" :class="baseerp+'btn'" :disabled="disabled">{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "SelfDetails",
        props:{
            productDetails:{
                type:Object,
                required:true,
            }
        },
        filters: {
            keepTwoNum(value){
                value = Number(value);
                return value.toFixed(2)
            }
        },
        data() {
            return {
                i_cjid:0,
                cpinput:"",
                multipleSelection:"",
                detailsData:[{i_id:1,f_jsdj:1,f_num:1}],
                /*currentPage:0,
                tableTotal:0,
                pageSize:1,
                pageCount:1,*/
                gsid:0,
                gsid_out:0,
                i_pzid:0,
                ckid:0,
                baseerp:"",
                mid:0,
                dataText:this.$t('tips_data_loading_in_progress'),
                disabled:false,
                selected:[],
            }
        },
        mounted() {
            this.baseerp=baseerp;
            //console.log(this.productDetails,"this.productDetails");
            this.getNhList();
            this.i_cjid=this.productDetails.i_cjid;
            this.gsid=this.productDetails.gsid;
            this.mid=this.productDetails.i_mid;
            this.ckid=this.productDetails.ckid;
            this.gsid_out=this.productDetails.gsid_out;
            this.i_pzid=this.productDetails.i_pzid;
            this.i_type=this.productDetails.i_type;
            this.selected=this.productDetails.selected;
            //this.getCjReturnPzList();
        },
        methods: {

            async getNhList(){
                let param={
                    i_mid: this.mid,
                    i_id:this.productDetails.i_id
                };
                let res=await API.getNhList(param);
                if(res.code==1){
                    if (res.data.length==0){
                        this.dataText=this.$t('tips_no_data_available_at_the_moment')
                    }
                    this.detailsData=res.data;
                    if (this.selected){
                        if (this.detailsData.length>0&&this.selected.length>0) {
                            this.selected.forEach(row => {
                                this.$refs.multipleTable.toggleRowSelection(row);
                            });
                        }
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },

            searchData(){
                this.detailsData=[];
                /*this.pageSize=1;
                this.currentPage=1;*/
                this.getCjReturnPzList();
            },

            cancel(){
                this.$emit('closePop');
            },

            handleSelectionChange:function(val) {
                this.multipleSelection = val;
                //console.log(val)
            },

            tableRowClassName({row,rowIndex}){
                //console.log(row.i_gsid,this.gsid)
                /*if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }*/
                //console.log(row,rowIndex,"row-class-name");
                if (row.isother == 1) {
                    return 'danger-row';
                }
            },

            saveForm(){
                this.disabled=true;
                this.$emit('transValue',this.multipleSelection);
                this.$emit('closePop');
            },

            pageCurrentChange(val){
                // console.log(val)
                this.detailsData=[];
                /*this.pageSize=val;
                this.currentPage=val;*/
                this.getCjReturnPzList();
            },
        },
    }
</script>

<style lang="scss" scoped>
    .searchName{
        width: 100px; display: inline-block;vertical-align: middle;text-align: center;
    }
    .mr10{
        width: 50%;
    }

    /deep/{
        .danger-row{
            color: #999;
        }
    }
</style>